// import secureLocalStorage from "react-secure-storage";

export const setToStorage = (key: string, data: any) => {
  localStorage.setItem(key, data);
};

export const getFromStorage = (key: any) => {
  return localStorage.getItem(key);
};

export const removeFromStorage = (key: string) => {
  localStorage.removeItem(key);
};
